import { Component, input } from '@angular/core';

export interface ToastMessage {
  id: number;
  type: 'info' | 'success' | 'error' | 'warning';
  message: string;
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.html',
  styleUrl: './toast.css',
})
export class Toast {
  toasts: ToastMessage[] = [];
  toastMessage = input<string>();

  show(type: ToastMessage['type'], message: string) {
    const toast: ToastMessage = {
      id: Date.now(),
      type,
      message,
    };
    this.toasts.push(toast);
  }

  remove(id: number): void {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
  }

  getToastColor(type: string): string {
    switch (type) {
      case 'success':
        return 'bg-success';
      case 'error':
        return 'bg-error';
      case 'warning':
        return 'bg-warning';
      case 'info':
        return 'bg-info';
      default:
        return 'bg-gray-500';
    }
  }
}
